import { moneyToNumber } from "./money";

const calcJobItemTotal = ({ newEditItem, job, customer, prices, lists }) => {
  let base_price, unitPrice, total;
  let baseColumn = ""; // base column for the job item to get price and cost values
  let extrasCostIds = []; // array of id's of items used from extras table to track cost
  let cost_materials = 0; // running cost of materials
  let cost_retail = 0; // running total of retail value to calculate tax
  let cost_labor = 0; // running total of labor (in man hours)
  let extras_price = 0;
  // let veluxFlashing = 0;
  const priceSheet = job.price_sheets_id;
  const roofer = customer.roofer_discount;
  const workType = newEditItem.work_types_id;
  const quantity = newEditItem.quantity;
  const size = newEditItem.skylight_sizes_id;
  const frame = newEditItem.frame_types_id;
  const glazing = newEditItem.top_glazing_id;
  const material = newEditItem.glazing_materials_id;
  const extras = newEditItem.extras_ids;
  const depth = newEditItem.tube_depths_id;
  const use_custom_price = newEditItem.use_custom_price;
  const custom_price = newEditItem.custom_price;
  const work_description = newEditItem.work_description;

  if (process.env.NODE_ENV === "development") {
    console.log("newEditItem:", newEditItem);
    console.log("prices:", prices);
  }
  // --- get pricing tables ---
  const standardPrice = (roofer ? prices.rooferSkylightPrices : prices.skylightPrices).filter(
    (record) =>
      parseInt(record.price_sheets_id) === parseInt(priceSheet) &&
      parseInt(record.skylight_sizes_id) === parseInt(size)
  );
  const skylightCostRow = prices.skylightCosts.filter(
    (record) =>
      parseInt(record.price_sheets_id) === parseInt(priceSheet) &&
      parseInt(record.skylight_sizes_id) === parseInt(size)
  );
  console.log("skylightCostRow:", skylightCostRow);
  let baseObject = skylightCostRow[0];
  const {
    domes_only,
    with_mill,
    with_bronze,
    sf_mill,
    sf_bronze,
    velux_clear,
    velux_white,
    sf_velux,
    reflash,
    // velux_flashing,
  } = standardPrice[0] || {};
  // labor price table
  const { service_call, labor_hourly, labor_cost } = prices.laborPrices.filter(
    (price) => parseInt(price.price_sheets_id) === parseInt(priceSheet)
  )[0];
  // sun tunnels price table
  const tunnelPrice = (roofer ? prices.rooferSunTunnelPrices : prices.sunTunnelPrices).filter(
    (record) =>
      parseInt(record.price_sheets_id) === parseInt(priceSheet) &&
      parseInt(record.skylight_sizes_id) === parseInt(size)
  );
  const sunTunnelCostRow = prices.sunTunnelCosts.filter(
    (record) =>
      parseInt(record.price_sheets_id) === parseInt(priceSheet) &&
      parseInt(record.skylight_sizes_id) === parseInt(size)
  );
  const { retail, labor_first, extension, retail_impact, retail_low_profile, tunnel } =
    tunnelPrice[0] || {};
  // line items
  const lineItemPrices = prices.extrasPrices.filter((record) => {
    return parseInt(record.price_sheets_id) === parseInt(priceSheet);
  });
  // ------====== Determine work type and assign base price and cost values ======------
  // --- Service Call ---
  if (workType === 2) {
    base_price = service_call;
    cost_labor = 1;
  }
  // --- Reflash/Reseal ---
  else if (workType === 4) {
    base_price = reflash;
    baseColumn = "reflash";

    // // flashing kit price
    // veluxFlashing = velux_flashing;
    // console.log("VELUX FLASHING 1:", velux_flashing);
  }
  // --- Sun tunnel base price ---
  else if (workType === 5) {
    // extension cost
    const sizeText = lists.listTubeDepths?.filter((item) => item.id === depth)[0]?.text;
    const template = /\d{1} extensions*/;
    const match = sizeText?.match(template);
    const numExtensions = match ? Number(match[0].charAt(0)) : 0;
    // calculate unit cost
    if (tunnel) {
      // --- NEW SUN TUNNEL PRICE CALCULATIONS ---
      const extensionId = size === 12 ? 11 : 12;
      const extensionRow = lineItemPrices.filter((item) => item.extras_id === extensionId)[0];
      const extensionPrice = extensionRow.price * numExtensions;
      baseObject = sunTunnelCostRow[0];
      // add cost values for one off item, extensions
      cost_retail = cost_retail + extensionRow.price_retail * numExtensions;
      cost_materials = cost_materials + extensionRow.price_materials * numExtensions;
      cost_labor = cost_labor + Number(extensionRow.price_labor) * numExtensions;

      console.log("lineItemPrices:", lineItemPrices);
      let unitCost = tunnel;
      if (frame === 6) {
        const lowProdifleId = 6;
        const lowProfilePrice = lineItemPrices.filter((item) => item.extras_id === lowProdifleId)[0]
          .price;
        unitCost = unitCost + lowProfilePrice;
        extrasCostIds.push(lowProdifleId);
      }
      if (frame === 7) {
        const impactId = 5;
        const impactPrice = lineItemPrices.filter((item) => item.extras_id === impactId)[0].price;
        unitCost = unitCost + impactPrice;
        extrasCostIds.push(impactId);
      }
      base_price = unitCost + extensionPrice;
      baseColumn = "tunnel";
    } else {
      // --- OLD PRICE CALCULATIONS ---
      // (used as fall back when new price values are missing)
      let unitCost = retail;
      if (frame === 6) {
        unitCost = retail_low_profile;
      }
      if (frame === 7) {
        unitCost = retail_impact;
      }
      // calculate base install cost
      base_price = unitCost + labor_first + extension * numExtensions;
    }
  }

  //  --- Custom base price ---
  else if (workType === 6) {
    // base_price = "custom";
  }
  //  --- Hourly base price ---
  else if (workType === 13) {
    base_price = labor_hourly;
    cost_labor = 1;
    console.log("setting labor price...", labor_hourly);
  }
  //  --- New Install price ---
  else if (workType === 14) {
    // base_price = "custom";
  }
  // --- All standard base prices ---
  else {
    // - Acrylic Dome Prices -
    if (material === 1) {
      // no frame
      if (frame === 100) {
        baseColumn = "domes_only";
        base_price = domes_only;
      }
      // mill frame curb mount
      else if (frame === 1) {
        baseColumn = "with_mill";
        base_price = with_mill;
      }
      // painted frame curb mount
      else if (frame === 2) {
        baseColumn = "with_bronze";
        base_price = with_bronze;
      }
      // mill frame self-flashing
      else if (frame === 3) {
        baseColumn = "sf_mill";
        base_price = sf_mill;
      }
      // painted frame self-flashing
      else if (frame === 4) {
        baseColumn = "sf_bronze";
        base_price = sf_bronze;
      }
    }
    // velux curb mount
    if (frame === 9) {
      baseColumn = glazing === 3 ? "velux_clear" : "velux_white";
      base_price = glazing === 3 ? velux_clear : velux_white;
    }
    // velux deck mount
    if (frame === 10) {
      baseColumn = glazing === 3 ? "sf_velux" : null;
      base_price = glazing === 3 ? sf_velux : null;
    }
  }

  // --------====== Line Item Prices ======--------
  let newDescription = work_description;
  // remove old line item descriptions
  const lineItemsStart = newDescription?.indexOf("\n\nLine Items:");
  if (lineItemsStart > -1) {
    newDescription = newDescription.slice(0, lineItemsStart);
  }
  // build new line item descriptions
  if (extras.length > 0) {
    newDescription += "\n\nLine Items:";
  }
  extras.forEach((extra) => {
    // extras.map((extra) => {
    let linePrice = 0;
    // get line item price for all standard extras
    const { price } = prices.extrasPrices.filter((record) => {
      return (
        parseInt(record.price_sheets_id) === parseInt(priceSheet) &&
        parseInt(record.extras_id) === parseInt(extra)
      );
    })[0]; // grab from the first (should be only) item in the array
    linePrice = price;
    extras_price += linePrice;
    const extraDesc = lists.listExtras.filter((item) => item.id === extra)[0].text;
    newDescription += `\n${extraDesc} - $${linePrice}.00`;
    console.log("price:", price);
    console.log("extra:", extra);
    extrasCostIds.push(extra);
  });

  // --------====== Expected Costs ======--------
  // provide expected base costs if present
  console.log("====== Expected Costs ======");
  console.log("baseObject calculation:", baseObject);
  console.log("baseColumn calculation:", baseColumn);
  if (baseColumn && baseObject) {
    console.log("cost_retail before calculation:", cost_retail);
    console.log("cost_materials before calculation:", cost_materials);
    console.log("cost_labor before calculation:", cost_labor);
    if (baseColumn !== "reflash") {
      cost_retail = cost_retail + baseObject[baseColumn + "_retail"];
    }
    cost_materials = cost_materials + baseObject[baseColumn + "_materials"];
    cost_labor = cost_labor + Number(baseObject[baseColumn + "_labor"]);
    console.log("cost_retail after calculation:", cost_retail);
    console.log("cost_materials after calculation:", cost_materials);
    console.log("cost_labor after calculation:", cost_labor);
  }
  // add any items from the extras table
  extrasCostIds.forEach((extraId) => {
    console.log("extraId:", extraId);
    const extraRow = lineItemPrices.filter((price) => price.extras_id === extraId)[0];
    cost_retail = cost_retail + extraRow.price_retail;
    cost_materials = cost_materials + extraRow.price_materials;
    cost_labor = cost_labor + Number(extraRow.price_labor);
  });

  // --------====== Final Tally ======--------
  if (use_custom_price) {
    unitPrice = moneyToNumber(custom_price);
  } else {
    unitPrice = base_price + extras_price;
  }
  total = unitPrice * quantity;
  // console.log("====================");
  // console.log("tunnelPrice[0]:", tunnelPrice[0]);
  // console.log("tunnel:", tunnel);
  // console.log("lineItemPrices:", lineItemPrices);
  // console.log("use_custom_price:", use_custom_price);
  // console.log("custom_price:", moneyToNumber(custom_price));
  // console.log("base_price:", base_price);
  // console.log("extras_price:", extras_price);
  // console.log("total:", total);
  // console.log("work_description:", newDescription);
  // console.log("-----------------------");
  // console.log("baseColumn:", baseColumn);
  // console.log("cost_retail:", cost_retail);
  // console.log("cost_materials:", cost_materials);
  // console.log("cost_labor:", cost_labor);
  return {
    base_price,
    extras_price,
    unitPrice,
    total,
    work_description: newDescription,
    labor_cost,
    cost_retail,
    cost_materials,
    cost_labor,
  };
};

export default calcJobItemTotal;
